import { Button, Typography, useMediaQuery } from "@mui/material";
import { useRef, useState } from "react";
import menu from "../../icons/menu.svg";
import logo from "../../images/bkv_logo.svg";
import {
  HeaderContent,
  HeaderStyled,
  HeaderTitleItem,
  HeaderTitleItems,
  RightSection,
} from "../styled/Header.styled";
import { PCDrawer } from "./PcDrawer";
import { HeaderTitleArray, MENU_BY_TITLE } from "./data";
import MobileDrawer from "./MobileDrawer";
import SearchBox from "./SearchBox";

export const HeaderV2 = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerContent, setDrawerContent] = useState();
  const [showMenu, setShowMenu] = useState(false);
  /* parent's nav bar collapses to the hamburger at 992px, not 1024 */
  const isPad = useMediaQuery("(max-width:992px)");
  const isShowPhone = useMediaQuery("(min-width:1441px)");
  /* a per-render local resets to undefined on every re-render, so clearTimeout() could
     no-op and the 300ms grace timer would still close the panel. A ref survives renders. */
  const hideTimer = useRef();
  const handleMouseEnter = (val, idx) => {
    if (val.title === "Login") return setShowDrawer(false);
    clearTimeout(hideTimer.current);
    /* Pay Bill and Login have no dropdown - skip so the panel does not open empty */
    if (!MENU_BY_TITLE[val.title]) {
      setShowDrawer(false);
      setDrawerContent(null);
      return;
    }
    setShowDrawer(true);
    setDrawerContent(val.title);
  };

  const handleMouseLeave = () => {
    hideTimer.current = setTimeout(() => {
      setShowDrawer(false);
      setDrawerContent(null);
    }, 300);
  };

  return (
    <>
      <HeaderStyled id="header">
        <HeaderContent>
          <img src={logo} className="logo" onClick={()=>{window.location.href =('https://bkvenergy.com/')}}/>
          {isPad ? (
            <div style={{ cursor: "pointer" }} onClick={()=>setShowMenu(true)}>
              {!showMenu && <img width="30px" height="30px" src={menu} />}
            </div>
          ) : (
            <HeaderTitleItems>
              {HeaderTitleArray.map((item, idx) => (
                <HeaderTitleItem
                  key={item.title}
                  className={showDrawer && drawerContent === item.title ? "active" : ""}
                  onMouseEnter={() => handleMouseEnter(item, idx)}
                  onMouseLeave={handleMouseLeave}
                >
                  <a
                    href={item.link}
                    aria-expanded={showDrawer && drawerContent === item.title}
                  >
                    {item.title}
                  </a>
                </HeaderTitleItem>
              ))}
            </HeaderTitleItems>
          )}

          <RightSection>
            {isShowPhone && <a href="tel:18552584797">1 855 BKV 4PWR</a>}
            <Button onClick={()=>window.open('https://enroll.bkvenergy.com/?promo=SEOEIQ0002')}>
              <Typography fontWeight={600}>FIND YOUR POWER</Typography>
            </Button>
            {!isPad && <SearchBox />}
          </RightSection>
        </HeaderContent>
      </HeaderStyled>
      {isPad ? (
        <MobileDrawer isOpen={showMenu} handleChangeShow={()=>setShowMenu(false)}/>
      ) : (
        <PCDrawer
          isOpen={showDrawer}
          content={drawerContent}
          onMouseEnter={() => clearTimeout(hideTimer.current)}
          onMouseLeave={() => {
            setShowDrawer(false);
            setDrawerContent(null);
          }}
        />
      )}
    </>
  );
};
